export const formDefaultValues = {
  name: '',
}
